import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
  withIncrementalHydration,
} from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { LOCALE_ID } from '@angular/core';
import { TokenInterceptor } from './interceptors/token-interceptor.service';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

// ÄNDERUNG 1: Import des Moment Adapters
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { MAT_DATE_FORMATS } from '@angular/material/core';

import { importProvidersFrom } from '@angular/core';
import { NgxEchartsModule } from 'ngx-echarts';
import { BlobErrorInterceptor } from './interceptors/blob-error-interceptor';
import { ErrorInterceptor } from './interceptors/error-interceptor';
import { provideQuillConfig } from 'ngx-quill';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY', // Wie das Datum geparst wird
  },
  display: {
    dateInput: 'DD.MM.YYYY', // Wie es im Input-Feld angezeigt wird
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
registerLocaleData(localeDe);

export const appConfig: ApplicationConfig = {
  providers: [
    provideQuillConfig({}),
    // ------------------------------
    // Router
    // ------------------------------
    provideRouter(routes, withComponentInputBinding(), withInMemoryScrolling({
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
  })),
    importProvidersFrom(
      NgxEchartsModule.forRoot({
        echarts: () => import('echarts'),
      }),
    ),
    // ------------------------------
    // SSR Hydration
    // ------------------------------
    provideClientHydration(withEventReplay(), withIncrementalHydration()),

    // ------------------------------
    // Change Detection
    // ------------------------------
    provideZonelessChangeDetection(),

    // ------------------------------
    // HTTP
    // ------------------------------
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BlobErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },

    // ------------------------------
    // Translation
    // ------------------------------
    provideTranslateService({
      fallbackLang: 'de',
      loader: provideTranslateHttpLoader({
        prefix: 'i18n/',
        suffix: '.json',
      }),
    }),

    // ------------------------------
    // Date Adapter (GEÄNDERT)
    // ------------------------------
    // Wir ersetzen den NativeAdapter durch Moment mit UTC-Option
    provideMomentDateAdapter(
      undefined, // Standard-Formate verwenden (kannst du anpassen)
      { useUtc: true }, // <--- DAS LÖST DEIN PROBLEM (verhindert Zeitzonen-Offset)
    ),
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    // ------------------------------
    // Locale
    // ------------------------------
    { provide: LOCALE_ID, useValue: 'de' },

    // ------------------------------
    // Error Listeners
    // ------------------------------
    provideBrowserGlobalErrorListeners(),
  ],
};
